module.exports = __webpack_public_path__ + "static/img/1747388215868.9e348a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/qrcode/1747388215868.png
// module id = 2QsZ
// module chunks = 7